import {
  PartnerDocumentListApi,
  PartnerDocumentListQuery,
  PartnerDocumentStats,
} from '../../partner-management/models/partner-document-listing-row';

export interface DocumentVerificationState {
  rows: PartnerDocumentListApi[];
  stats: PartnerDocumentStats;
  totalDocuments: number;
  loadingList: boolean;
  submitting: boolean;
  error: string | null;
  listError: string | null;
  successMessage: string | null;
  currentPage: number;
  pageSize: number;
  listQuery: PartnerDocumentListQuery | null;
}

export const initialDocumentVerificationState: DocumentVerificationState = {
  rows: [],
  stats: {
    pending_review: 0,
    approved: 0,
    rejected: 0,
  },
  totalDocuments: 0,
  loadingList: false,
  submitting: false,
  error: null,
  listError: null,
  successMessage: null,
  currentPage: 1,
  pageSize: 10,
  listQuery: null,
};
